import Vue from 'vue'
import store from '@/store'

Vue.filter('NumberFormat', function (value) {
    if (!value) {
        return '0'
    }
    const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
    return intPartFormat
})

Vue.filter('substrs', function (value) {
    if (!value) {
        return '0'
    }
    return value.substring(5, 10);
})

Vue.filter('getAge', function (strBirthday) {
    let returnAge,
        strBirthdayArr = strBirthday.split("-"),
        birthYear = strBirthdayArr[0],
        birthMonth = strBirthdayArr[1],
        birthDay = strBirthdayArr[2],
        d = new Date(),
        nowYear = d.getFullYear(),
        nowMonth = d.getMonth() + 1,
        nowDay = d.getDate();
    if (nowYear == birthYear) {
        returnAge = 0;//同年 则为0周岁
    } else {
        var ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay;//日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                var monthDiff = nowMonth - birthMonth;//月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge;//返回周岁年龄
})

Vue.filter('orderss', function (tt) {
    if (tt == 0) {
        return "待付款"
    } else if (tt == 20) {
        return "待接单"
    } else if (tt == 30) {
        return "待完成"
    } else if (tt == 40) {
        return "待评价"
    } else if (tt == 100) {
        return "已取消"
    } else if (tt == 50) {
        return "全部订单"
    }

})


Vue.filter('substrs2', function (value) {
    if (!value) {
        return '0'
    }
    return value.substring(5, 20);
})

Vue.filter('substrs3', function (value) {
    if (!value) {
        return '0'
    }
    return value.substring(0, 10);
})

/**
 * sysdict 字典表
 * @param key key
 * @param type 类型
 * @returns {string|*} value值
 */
export const SysDictFilter = (key, type) => {
    if (key !== undefined && key !== '') {
        const dictListForType = store.getters.sysDictListForType(type)
        if (dictListForType) {
            return dictListForType['wx' + key].v
        }
    }
    return ''
}

/**
 * sysParam 系统参数
 * @param key key
 * @param type 类型
 * @returns {string|*} value值
 */
export const SysParamFilter = (key) => {
    if (key !== undefined && key !== '') {
        const dictListForType = store.getters.sysParamDataForType(key)
        if (dictListForType) {
            return dictListForType
        }
    }
    return ''
}

export const SysGetAge = (strBirthday) => {
    let returnAge,
        strBirthdayArr = strBirthday.split("-"),
        birthYear = strBirthdayArr[0],
        birthMonth = strBirthdayArr[1],
        birthDay = strBirthdayArr[2],
        d = new Date(),
        nowYear = d.getFullYear(),
        nowMonth = d.getMonth() + 1,
        nowDay = d.getDate();
    if (nowYear == birthYear) {
        returnAge = 0;//同年 则为0周岁
    } else {
        var ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay;//日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                var monthDiff = nowMonth - birthMonth;//月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
        }
    }
    return returnAge;//返回周岁年龄
}

/**
 *  sysdict 字典表
 * @param type 类型
 * @returns {string|*} value值
 */
export const SysDictOptions = (type) => {
    if (type !== undefined && type !== '') {
        const dictListForType = store.getters.sysDictListForType(type)
        if (dictListForType) {
            return dictListForType
        }
    }
    return []
}

/**
 *  图片过滤
 */
export const ImgCheck = (value) => {
    if (!value) {
        return ''
    }
    return value.replace(/<img([\s\w"-=/.:;]+)((?:(height="[^"]+")))/ig, '<img$1')
        .replace(/<img([\s\w"-=/.:;]+)((?:(width="[^"]+")))/ig, '<img$1')
        .replace(/<img([\s\w"-=/.:;]+)((?:(style="[^"]+")))/ig, '<img$1')
        .replace(/<img([\s\w"-=/.:;]+)((?:(alt="[^"]+")))/ig, '<img$1')
        .replace(/<img([\s\w"-=/.:;]+)/ig, '<img style="width: 100%;" $1');
}

/**
 * 字符串保留首尾两位，中间字符串由*星号替换
 * @param str
 * @returns {*}
 * @constructor
 */
export const ParseStringToStar = (str) => {
    return str.length > 2 ? str.substr(0, 1) + new Array(str.length - 2).join('*') + str.substr(-1) : str
}

/**
 * 获取文件访问路径
 * @param avatar
 * @param imgerver
 * @param str
 * @returns {*}
 */
export const GetFileAccessHttpUrl = (avatar, imgerver, subStr) => {
    if (!imgerver) {
        imgerver = process.env.VUE_APP_IMG_BASE_URL
    }
    if (!subStr) {
        subStr = 'http'
    }
    if (avatar && avatar.indexOf(subStr) !== -1) {
        return avatar
    } else {
        return imgerver + avatar
    }
}

export function toFixedFun(data, len) {
    // debugger
    const number = Number(data);
    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString();
    }
    if (typeof (len) === 'undefined' || len === 0) {
        return (Math.round(number)).toString();
    }
    let result = number.toString();
    const numberArr = result.split('.');

    if (numberArr.length < 2) {
        // 整数的情况
        return padNum(result);
    }
    const intNum = numberArr[0]; // 整数部分
    const deciNum = numberArr[1];// 小数部分
    const lastNum = deciNum.substr(len, 1);// 最后一个数字

    if (deciNum.length === len) {
        // 需要截取的长度等于当前长度
        return result;
    }
    if (deciNum.length < len) {
        // 需要截取的长度大于当前长度 1.3.toFixed(2)
        return padNum(result);
    }
    // 需要截取的长度小于当前长度，需要判断最后一位数字
    result = `${intNum}.${deciNum.substr(0, len)}`;
    if (parseInt(lastNum, 10) >= 5) {
        // 最后一位数字大于5，要进位
        const times = Math.pow(10, len); // 需要放大的倍数
        let changedInt = Number(result.replace('.', ''));// 截取后转为整数
        changedInt++; // 整数进位
        changedInt /= times;// 整数转为小数，注：有可能还是整数
        result = padNum(`${changedInt}`);
    }
    return result;

    // 对数字末尾加0
    function padNum(num) {
        const dotPos = num.indexOf('.');
        if (dotPos === -1) {
            // 整数的情况
            num += '.';
            for (let i = 0; i < len; i++) {
                num += '0';
            }
            return num;
        } else {
            // 小数的情况
            const need = len - (num.length - dotPos - 1);
            for (let j = 0; j < need; j++) {
                num += '0';
            }
            return num;
        }
    }
}

export const formatDate = (value, format) => {
    // 时间戳转换成日期
    let date = new Date(value);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    let s = date.getSeconds();
    let result = "";
    if (format == undefined) {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
            h < 10 ? "0" + h : h
        }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
    }
    if (format == "yyyy-MM-dd") {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    }
    if (format == "yyyy.MM.dd") {
        result = `${y}.${m < 10 ? "0" + m : m}.${d < 10 ? "0" + d : d}`;
    }
    if (format == "yyyy-MM") {
        result = `${y}-${m < 10 ? "0" + m : m}`;
    }
    if (format == "yyyy.MM") {
        result = `${y}.${m < 10 ? "0" + m : m}`;
    }
    if (format == "MM-dd") {
        result = `${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    }
    if (format == "MM.dd") {
        result = `${m < 10 ? "0" + m : m}.${d < 10 ? "0" + d : d}`;
    }
    if (format == "hh:mm") {
        result = ` ${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
    }
    if (format == "yyyy") {
        result = `${y}`;
    }
    return result;
}

Vue.filter('formatDate', function (value, format) {
    // 时间戳转换成日期
    let date = new Date(value);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    let s = date.getSeconds();
    let result = "";
    if (format == undefined) {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
            h < 10 ? "0" + h : h
        }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
    }
    if (format == "yyyy-MM-dd") {
        result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    }
    if (format == "yyyy.MM.dd") {
        result = `${y}.${m < 10 ? "0" + m : m}.${d < 10 ? "0" + d : d}`;
    }
    if (format == "yyyy-MM") {
        result = `${y}-${m < 10 ? "0" + m : m}`;
    }
    if (format == "yyyy.MM") {
        result = `${y}.${m < 10 ? "0" + m : m}`;
    }
    if (format == "MM-dd") {
        result = `${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    }
    if (format == "MM.dd") {
        result = `${m < 10 ? "0" + m : m}.${d < 10 ? "0" + d : d}`;
    }
    if (format == "hh:mm") {
        result = ` ${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
    }
    if (format == "yyyy") {
        result = `${y}`;
    }
    return result;
})
